import { useState } from "react";
import styles from "./style.module.css";
import { CopyBlock, dracula } from "react-code-blocks";
import * as querystring from "query-string";

export const LandingPage = () => {
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [language, setLanguage] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [gymId, setGymId] = useState("");

  const generateHTML = () => {
    let html = "";

    let url = `${process.env.REACT_APP_BOOKING_CALENDAR_URL}/calendar/gym/${gymId}`;

    const params: {
      primaryColor?: string;
      secondaryColor?: string;
      language?: string;
      redirectUrl?: string;
    } = {};

    if (primaryColor) {
      params.primaryColor = primaryColor;
    }

    if (secondaryColor) {
      params.secondaryColor = secondaryColor;
    }

    if (language) {
      params.language = language;
    }

    if (redirectUrl) {
      params.redirectUrl = redirectUrl;
    }

    const qs = querystring.stringify(params);
    if (qs) {
      url += `?${qs}`;
    }

    html += `<iframe src="${url}" width="100%" height="100%" frameborder="0">`;
    html += "</iframe>";

    return html;
  };

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1>Membr Booking Preview Widget</h1>
      <p>{`Use Path to generate widget: /calendar/gym/{gymId}`}</p>
      <p>
        <strong>Available Query Parameters:</strong>
      </p>
      <div className={styles.inputContainer}>
        <strong>Gym ID (Required):</strong>
        <input
          value={gymId}
          placeholder="Membr Gym ID"
          onChange={(event) => setGymId(event.target.value)}
        />
      </div>
      <div className={styles.inputContainer}>
        <strong>PrimaryColor:</strong>
        <input
          value={primaryColor}
          placeholder="red or hex"
          onChange={(event) => setPrimaryColor(event.target.value)}
        />
      </div>
      <div className={styles.inputContainer}>
        <strong>SecondaryColor:</strong>
        <input
          value={secondaryColor}
          placeholder="blue or hex"
          onChange={(event) => setSecondaryColor(event.target.value)}
        />
      </div>
      <div className={styles.inputContainer}>
        <strong>Language:</strong>
        <span>Available languages: en</span>
        <input
          value={language}
          placeholder="en"
          onChange={(event) => setLanguage(event.target.value)}
        />
      </div>
      <div className={styles.inputContainer}>
        <strong>
          Redirect URL (if not provided http://membr.com will be used):
        </strong>
        <input
          value={redirectUrl}
          placeholder="website URL when click 'Book'"
          onChange={(event) => setRedirectUrl(event.target.value)}
        />
      </div>
      {gymId && (
        <CopyBlock
          text={generateHTML()}
          language="html"
          showLineNumbers={false}
          theme={dracula}
          codeBlock
          wrapLongLines
          customStyle={{
            width: 500,
          }}
        />
      )}
    </div>
  );
};
